/**
 * @brief   Singleton de AppAjax.
 * @see     resources/js/scripts/functions/AppAjax.class.js
 */
require('./functions/AppAjax.class');
let AppAjax = window.AppAjax;

/*
|--------------------------------------------------------------------------
| DEBUT DU FICHIER - NE RIEN AJOUTER D'AUTRE QUE require() AU DESSUS !
|--------------------------------------------------------------------------
*/

/**
 * @brief   Fonctionnalités de la page des soumissions
 */
jQuery(document).ready(function() {
    // Exécution du code uniquement si l'élément du DOM existe
    if (jQuery('section[class^=section-soumissions]').html() !== undefined) {
        // Méthodes JavaScript communes
        require('./functions/validators.functions');
        // Méthodes jQuery communes
        require('./jquery/clients.jquery');
        require('./jquery/documents.jquery');
        require('./jquery/upload.jquery');
        /** DEBUT DU CODE JAVASCRIPT EN DESSOUS DE CETTE PARTIE ! */

        // Update total quote function
        let updateTotalQuote = function() {
            let totalPrice = 0;
            // To add the empty tr if all is deleted
            if ($('.quote-table-form').find('tr.measure-box').length === 0) {
                $('.quote-table-form').find('tr.empty').css('display', 'table-row');
            } else {
                //Update the total price if we remove a row
                $('.display-total_price').each(function() {
                    totalPrice += parseFloat($(this).text());
                });
            }
            // Update total quote input
            $('input[name="total_quote"]').val(totalPrice.toFixed(2));
        };

        //#####################################################
        // Dropdown filters
        //#####################################################
        var titleFilter = document.querySelector('.submisions-title');
        var quotesFilter = document.querySelector('.submisions-filters');

        // Add a click event to the title element
        $(titleFilter).on('click', function() {
            // Toggle the "open" class on the filters element
            $(quotesFilter).toggleClass('open');
            $(titleFilter).toggleClass('active');
        });

        var myModal = $('#myModal');
        var myInput = $('#myInput');

        if (myModal.length) {
            myModal.on('shown.bs.modal', function() {
                myInput.focus();
            });
        }

        //#####################################################
        // Send copy quote url to the modale form action
        //#####################################################
        $('button.copy-quote-btn').on('click', function() {
            $('form#confirm-copy-quote').attr('action', $(this).data('url'));
            $('.modal_reference_number').text($(this).data('ref'));
        });

        //#####################################################
        // Send cancel quote url to the modale form action
        //#####################################################
        $('button.cancel-quote-btn').on('click', function() {
            $('form#confirm-cancel-quote').attr('action', $(this).data('url'));
            $('.modal_reference_number').text($(this).data('ref'));
        });

        //#####################################################
        // Add rows and manage the table options
        //#####################################################
        var rowNumber = 0;

        // Change label product selection
        $('select#product_id').on('change', function() {
            $('#add-measure-btn').prop('disabled', $(this).val() === '');
            var product_id = $(this).find('option:selected').val();

            // Update density from Ajax product search by id
            AppAjax.updateInput('input.hidden-density', 'product_density', { id: product_id });

            // Update each active items
            $('tr.active, .measure-box tbody').each(function() {
                $(this).find('.hidden-product_id').val(product_id);
            });
        });

        // Change label ring if selected
        $('select#quote_line_type').on('change', function() {
            var type = $(this).find('option:selected').val();

            if (type.toLowerCase() === 'ring') {
                if (window.lang === 'fr') {
                    $('.label-width').text('Diamètre externe');
                    $('.label-length').text('Diamètre interne');
                } else {
                    $('.label-width').text('External diameter');
                    $('.label-length').text('Internal diameter');
                }
            } else {
                if (window.lang === 'fr') {
                    $('.label-width').text('Largeur');
                    $('.label-length').text('Longueur');
                } else {
                    $('.label-width').text('Width');
                    $('.label-length').text('Longueur');
                }
            }
        });

        // Change inch to mm and display new size results
        $('#unit_radio input[name="quote_line_measure"]').on('change', function() {
            var selectedValue = $(this).val();
            var th = $('#mytable .label-price');
            var density = $('input.hidden-density').val();

            if (selectedValue === 'Milimeters'){
                th.find('#kg').removeClass('hidden');
                th.find('#lb').addClass('hidden');
            }
            else{
                th.find('#kg').addClass('hidden');
                th.find('#lb').removeClass('hidden');
            }

            $('tr, .measure-box tbody').each(function() {
                var row = $(this);
                var thickness = row.find('.input-thickness').val();
                var width = row.find('.input-width').val();
                var length = row.find('.input-length').val();
                var poids = row.find('.hidden-weight').val();
                var prix = row.find('.input-unit_price').val();
                var unit = 25.4;
                var facteur = .454;

                if (selectedValue === 'Milimeters') {
                    var thickness_mm = parseFloat(thickness) * parseFloat(unit);
                    var width_mm = parseFloat(width) * parseFloat(unit);
                    var length_mm = parseFloat(length) * parseFloat(unit);
                    var poids_kg = parseFloat(poids) * parseFloat(facteur);
                    var prix_kg = parseFloat(prix) / parseFloat(facteur);

                    row.find('.display-thickness').text(thickness_mm.toFixed(2));
                    row.find('.display-width').text(width_mm.toFixed(2));
                    row.find('.display-length').text(length_mm.toFixed(2));
                    row.find('.display-weight').text(poids_kg.toFixed(2));
                    row.find('.display-unit_price').text(prix_kg.toFixed(2));
                } else {
                    // Handle the default value here
                    row.find('.display-thickness').text(thickness);
                    row.find('.display-width').text(width);
                    row.find('.display-length').text(length);
                    row.find('.display-weight').text(poids);
                    row.find('.display-unit_price').text(prix);
                }

                // Update hidden field
                row.find('.hidden-quote_line_measure').val(selectedValue);
            });
        });

        // Change price if weight or unit and adjust the total price
        $('select#price_base_type').on('change', function() {
            var price_base_type = $(this).find('option:selected').val();

            if (window.lang === 'fr') {
                $('.label-price_lb').text(price_base_type === 'weight' ? 'Prix/Lb' : 'Prix/Unité');
            } else {
                $('.label-price_lb').text(price_base_type === 'weight' ? 'Price/Lb' : 'Price/Unit');
            }

            // Update each active items
            var updated = false;
            $('tr.active, .measure-box tbody').each(function() {
                var row = $(this);
                row.find('.hidden-price_base_type').val(price_base_type);
                var quantity    = row.find('.input-quantity').val();
                var thickness   = row.find('.input-thickness').val();
                var width       = row.find('.input-width').val();
                var length      = row.find('.input-length').val();
                var unit_price  = row.find('.input-unit_price').val();
                var density     = $('input.hidden-density').val();
                var total_price;

                // Calculate the weight price
                var weight = parseInt(quantity) * parseFloat(thickness) * parseFloat(width) * parseFloat(length) * parseFloat(density);
                // Update weight
                row.find('.display-weight').text(weight.toFixed());
                row.find('.hidden-weight').val(weight.toFixed());

                if (price_base_type.toLowerCase() === 'weight') {
                    total_price = weight.toFixed() * parseFloat(unit_price);
                } else {
                    // Calculate the unit price
                    total_price = parseFloat(unit_price) * parseInt(quantity);
                }

                // Display results
                row.find('.display-total_price').text(total_price.toFixed(2));
                row.find('.hidden-total_price').val(total_price.toFixed(2));
                updated = true;
            });

            if (updated) {
                // Update total price
                updateTotalQuote();
            }
        });

        // Add row for a new measure
        $('#add-measure-btn').on('click', function() {
            rowNumber++;
            var quote_line_measure  = $('input#quote_line_measure:checked').val();
            var product_id          = $('select#product_id option:selected').val();
            var quote_line_type     = $('select#quote_line_type option:selected').val();
            var price_base_type     = $('select#price_base_type option:selected').val();

            $('.quote-table-form').find('tr.empty').css('display', 'none');
            $('.quote-table-form').find('tr.measure-box').css('display', 'table-row');

            // Get model HTML content
            var quote_line_html = require('./models/quote_line.html');
            $('.quote-table-form').find('tbody').prepend(quote_line_html.replace(/%id%/g, rowNumber)
                                                                             .replace("%quote_line_measure%", quote_line_measure)
                                                                             .replace("%product_id%", product_id)
                                                                             .replace("%quote_line_type%", quote_line_type)
                                                                             .replace("%price_base_type%", price_base_type));

            // Test density value
            var density = $('input#density').val();
            if (parseFloat(density) === 0) {
                // Update density from Ajax product search by id
                AppAjax.updateInput('input.hidden-density', 'product_density', {id: product_id});
            }
        });

        // Check if input are empty are not - Disabled/not disabled CTA
        var quoteTable = $('.quote-table-form');
        quoteTable.on('input', '.input-quantity, .input-thickness, .input-width, .input-length', function(event) {
            var row = $(this).closest('tr');
            var inputsInSameRow = $(this).closest('tr').find('.input-quantity, .input-thickness, .input-width, .input-length');
            var allFilled = inputsInSameRow.toArray().every(input => input.value !== '');

            if (allFilled) {
                var quote_line_type = $('select#quote_line_type option:selected').val();
                var quantity        = row.find('.input-quantity').val();
                var thickness       = row.find('.input-thickness').val();
                var width           = row.find('.input-width').val();
                var length          = row.find('.input-length').val();
                var density         = $('input.hidden-density').val();

                if (quote_line_type.toLowerCase() === 'ring') {
                    var inner_value = parseFloat(length);
                    var outer_value = parseFloat(width);

                    if (inner_value < outer_value) {
                        row.find('.input-width').removeClass('error');
                        row.find('.input-length').removeClass('error');
                    } else {
                        $('#alert-modal').modal('show');
                        row.find('.input-width').addClass('error');
                        row.find('.input-length').addClass('error');
                        event.preventDefault();
                        return false;
                    }
                }

                // Update next span from each input
                row.find('input.decimal,input.numeric').each(function() {
                    $(this).siblings('span').text($(this).val());
                });

                // Calculate the weight
                var weight = parseInt(quantity) * parseFloat(thickness) * parseFloat(width) * parseFloat(length) * parseFloat(density);

                // Update weight
                row.find('.display-weight').text(weight.toFixed());
                row.find('.hidden-weight').val(weight.toFixed());

                var unit_price = row.find('.input-unit_price').val();
                if (weight !== '' && unit_price !== '') {
                    // Enable "Save" button within the same row
                    row.find('.save-row').prop('disabled', false);
                    row.find('.cancel-row').prop('disabled', false);
                }
            } else {
                // Update weight
                row.find('.display-weight').text('');
                row.find('.hidden-weight').val('');
                // Disable "Save" button within the same row
                row.find('.save-row').prop('disabled', true);
                row.find('.cancel-row').prop('disabled', true);
            }
        });
        quoteTable.on('input', '.input-unit_price', function() {
            var inputsInSameRow = $(this).closest('tr').find('.hidden-density, .hidden-weight, .input-unit_price');
            var allFilled = inputsInSameRow.toArray().every(input => input.value !== '');

            // Get the "Save" button within the same row
            var saveBtnInSameRow = $(this).closest('tr').find('.save-row');
            var saveBtnInSameRow1 = $(this).closest('tr').find('.cancel-row');

            // Enable or disable the "Save" button based on the filled status of the input fields in the same row
            var isDisabled = true;
            if (allFilled) {
                isDisabled = false;
            }
            saveBtnInSameRow.prop('disabled', isDisabled);
            saveBtnInSameRow1.prop('disabled', isDisabled);
        });

        //#####################################################
        // Save btn event
        //#####################################################
        quoteTable.on('click', '.save-row', function(event) {
            var row = $(this).closest('tr');
            var price_base_type = $('select#price_base_type option:selected').val();
            var product_id      = $('select#product_id option:selected').val();
            var quote_line_type = $('select#quote_line_type option:selected').val();
            var total_price;

            // Update hidden fields
            row.find('.hidden-price_base_type').val(price_base_type);
            row.find('.hidden-product_id').val(product_id);
            row.find('.hidden-quote_line_type').val(quote_line_type);

            var quantity   = row.find('.input-quantity').val();
            var unit_price = row.find('.input-unit_price').val();
            var weight     = row.find('.hidden-weight').val();

            // Update next span from each input
            row.find('input.decimal,input.numeric').each(function() {
                $(this).siblings('span').text($(this).val());
            });

            // Calculate the total price
            if (price_base_type.toLowerCase() === 'weight') {
                total_price = parseFloat(weight) * parseFloat(unit_price);
            } else {
                // Calculate the unit price
                total_price = parseFloat(unit_price) * parseInt(quantity);
            }

            // Update results
            row.find('.display-total_price').text(total_price.toFixed(2));
            row.find('.hidden-total_price').val(total_price.toFixed(2));

            row.removeClass('active');
            $('#add-measure-btn').prop('disabled', false);

            // Update total price
            updateTotalQuote();
        });

        //#####################################################
        // Edit btn event
        //#####################################################
        quoteTable.on('click', '.edit-input-display', function() {
            var row = $(this).closest('tr');
            row.addClass('active');
            $('#add-measure-btn').prop('disabled', true);

            // Display the current option value on the current tr
            var selectedProductValue = $('select#product_id option:selected').val();
            var getProductValue = row.find('input[name^=hidden_product_id]').val();
            if (selectedProductValue !== getProductValue) {
                // Change selection
                $('select#product_id').val(getProductValue).change();
            }

            var selectedPriceBaseTypeValue = $('select#price_base_type option:selected').val();
            var getPriceBaseTypeValue = row.find('input[name^=hidden_price_base_type]').val();
            if (selectedPriceBaseTypeValue !== getPriceBaseTypeValue) {
                // Change selection
                $('select#price_base_type').val(getPriceBaseTypeValue).change();
            }

            var selectedQuoteTypeValue = $('select#quote_line_type option:selected').val();
            var getQuoteTypeValue = row.find('input[name^=hidden_quote_line_type]').val();
            if (selectedQuoteTypeValue !== getQuoteTypeValue) {
                // Change selection
                $('select#quote_line_type').val(getQuoteTypeValue).change();
            }
        });

        //#####################################################
        // Cancel btn event
        //#####################################################
        quoteTable.on('click', '.cancel-row', function(event) {
            var allInputsFilled = true;
            var saveBtnInSameRow = $(this).closest('tr').find('.save-row');

            $(this).closest('tr').find('input').each(function() {
                if (!$(this).val()) {
                    event.preventDefault();
                    allInputsFilled = false;
                    return false;
                }
            });

            if (allInputsFilled) {
                $(this).closest('tr').find('input').val('');
                saveBtnInSameRow.prop('disabled', true);
            } else {
                $(this).closest('tr').remove();
            }

            // To add the empty tr if all is deleted
            if ($('.quote-table-form').find('tr.measure-box').length === 0) {
                $('.quote-table-form').find('tr.empty').css('display', 'table-row');
            }
        });

        //#####################################################
        // Delete btn event
        //#####################################################
        // Remove the row from the modal
        $(document).on('click', '.remove-row-display', function() {
            var rowToDelete = $(this).closest('.measure-box');
            $('#remove-row-modal').data('rowToDelete', rowToDelete);
            // Update total price
            updateTotalQuote();
        });

        $(document).on('click', '#modal-delete-row', function() {
            var rowToDelete = $('#remove-row-modal').data('rowToDelete');
            rowToDelete.remove();
            // Update total price
            updateTotalQuote();
        });

        //#####################################################
        // Add/Remove emails page formulaire de soumissions
        //#####################################################
        $('#btn_add_email').on('click', function() {
            var email = $('#add_email_cc').val();
            if (window.isValidEmail(email)) {
                // Check if email is already in the list
                if ($('.display-cc-emails:contains(' + email + ')').length > 0) {
                    // Show error message and clear input field
                    $('.get-email').val('');
                    $('.add-email').addClass('disabled').attr('aria-disabled', 'true');
                    $('.get-email').attr('placeholder', window.lang === 'fr' ? 'Le courriel existe déjà !' : 'Email already exists!');
                    return;
                }

                var emailSpan = '<span>%email%&nbsp;&nbsp;<i class="bi bi-x"></i><input type="hidden" name="email[]" value="%email%"></span>';
                var newItem = $('<div class="email-item">').html(emailSpan.replace(/%email%/g, email));
                $('.display-cc-emails').append(newItem);

                $('#add_email_cc').val('');
                $(this).prop('disabled', true);
            }
        });

        $('#add_email_cc').on('input', function() {
            var email = $(this).val();
            var valid = window.isValidEmail(email);
            $('#btn_add_email').prop('disabled', !valid);
        });
        
        // Remove the div when the "bi-x" icon is clicked
        $('.display-cc-emails').on('click', '.bi-x', function() {
            $(this).parent().remove();
        });
        
        // Remove the error message when the input field is clicked
        $('#add_email_cc').on('click', function() {
            if ($(this).val() === 'Email already added!') {
                $(this).val('');
            }
        });
        
        /** FIN DU CODE JAVASCRIPT AU DESSUS DE CETTE PARTIE ! */
    }
});
/*
|--------------------------------------------------------------------------
| FIN DU FICHIER - NE RIEN AJOUTER EN DESSOUS !
|--------------------------------------------------------------------------
*/
